import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import API_BASE_URL from '../../config';
import './IPInfo.css';

const IPInfo = () => {
  const [ip, setIp] = useState('');
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleFetch = async () => {
    if (!ip.trim()) return;
    
    setLoading(true);
    setInfo(null);

    try {
      const res = await axios.post(`${API_BASE_URL}/diagnostic-tools/ipinfo`, { ip });
      
      const { readme, ...filteredData } = res.data;
      setInfo(filteredData);
    } catch (error) {
      setInfo({ error: t('ipInfo.error') });
    } finally {
      setLoading(false);
    }
  };

  const renderInfo = (data) => {
    if (data.error) return <div className="ipinfo-error">{data.error}</div>;

    return Object.entries(data).map(([key, value]) => (
      <div className="ipinfo-row" key={key}>
        <span className="ipinfo-key">{t(`ipFields.${key}`, key)}:</span>
        <span className="ipinfo-value">{value}</span>
      </div>
    ));
  };

  return (
    <div className="ipinfo-container">
      <h3 className="ipinfo-title">📍 {t('diagnosticTools.ipinfo')}</h3>
      <input
        className="ipinfo-input"
        placeholder={t('placeholders.ip')}
        value={ip}
        onChange={e => setIp(e.target.value)}
      />
      <button className="ipinfo-button" onClick={handleFetch} disabled={loading}>
        {loading ? t('buttons.loading') : t('buttons.getInfo')}
      </button>

      {info && <div className="ipinfo-result">{renderInfo(info)}</div>}
    </div>
  );
};

export default IPInfo;